import { setContext } from "@apollo/client/link/context";
import { useAuthStore } from "@domains/auth/utils/useAuthStore";
import { env } from "../../..";
import { UserRole } from "../../generated";
import { createAuthorizationHeader } from "../../utils";

export const authLink = (role?: UserRole, impersonatingEmployeeId?: string) =>
  setContext(async (req, { headers }) => {
    const tokenToUse = useAuthStore.getState().accessToken || "";

    if (req.operationName === "CurrentUser") {
      impersonatingEmployeeId = "";
    }

    return {
      headers: {
        ...headers,
        "hypercard-authorization": env.hypercardAuthorization,
        "x-view-as-role": role?.toString(),
        "x-impersonate-as-employee-profile-id": impersonatingEmployeeId ?? "",
        Authorization: createAuthorizationHeader(tokenToUse),
      },
    };
  });
